let id = 0;
export function uniqueId() {
    id++;
    return id;
}
